import { useRouteLoaderData } from '@remix-run/react';

import { resolveRichEditorImageSrc } from '~/utils/images';

interface CmsImageProps {
  data: {
    align?: 'left' | 'center' | 'right';
    link?: string;
    link_type?: 'internal' | 'external';
    alt?: string;
    title?: string;
    image: string;
  };
}

const CmsImage = ({ data }: CmsImageProps) => {
  const rootData = useRouteLoaderData<typeof import('~/root').loader>('root');
  const alignment = data.align || 'inherit';
  const linkTarget = data.link_type === 'external' ? '_blank' : '_self';
  const altText = data.alt || '';
  const titleText = data.title || '';
  const imageSrc = resolveRichEditorImageSrc(rootData?.ENV.API_URL, data.image);

  return (
    <div className="cms-image" style={{ textAlign: alignment }}>
      {data.link ? (
        <a href={data.link} target={linkTarget}>
          <img className="img-fluid cms-image__img" src={imageSrc} alt={altText} title={titleText} decoding="async" />
        </a>
      ) : (
        <img className="img-fluid cms-image__img" src={imageSrc} alt={altText} title={titleText} decoding="async" />
      )}
    </div>
  );
};

export default CmsImage;
